import React from "react";
import { Form, Button, Col, Row, Select } from "antd";

import { CategoryName, MakeModelInfoStatusText } from "../../../models";
import { useMakes } from "../../../routes/Configuration/hooks";
import styles from "./makeModelInfoFilterForm.scss";

const MakeModelInfoFilterForm = ({ value, onSubmit, onNew, form }) => {
  // car makes with their models (configuration/makes?category=car)
  const makes = useMakes(CategoryName.car) || [];
  const selectedMakeId = form.getFieldValue("makeId") || (value && value.makeId);
  const selectedMake = makes.find((m: any) => m.id === selectedMakeId);
  const models = (selectedMake && selectedMake.models) || [];

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const values = form.getFieldsValue();
    const params: any = {};
    if (values.makeId) params.makeId = values.makeId;
    if (values.modelId) params.modelId = values.modelId;
    if (values.status !== undefined && values.status !== null) {
      params.status = values.status;
    }
    onSubmit(params);
  };

  const handleReset = () => {
    form.resetFields();
    onSubmit({});
  };

  const handleMakeChange = () => {
    form.setFieldsValue({ modelId: undefined });
  };

  return (
    <Row gutter={2} className={styles.form}>
      <Form layout="horizontal" onSubmit={handleSubmit}>
        <Col md={12} sm={24} lg={5} xl={5}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("makeId", {
              initialValue: value && value.makeId
            })(
              <Select
                placeholder="Marka"
                showSearch
                allowClear
                optionFilterProp="children"
                onChange={handleMakeChange}
              >
                {makes.map((m: any) => (
                  <Select.Option key={m.id} value={m.id}>
                    {m.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={5} xl={5}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("modelId", {
              initialValue: value && value.modelId
            })(
              <Select
                placeholder="Model"
                showSearch
                allowClear
                optionFilterProp="children"
                disabled={!selectedMakeId}
              >
                {models.map((m: any) => (
                  <Select.Option key={m.id} value={m.id}>
                    {m.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col md={12} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            {form.getFieldDecorator("status", {
              initialValue: value && value.status
            })(
              <Select placeholder="Status" allowClear>
                {MakeModelInfoStatusText.map(opt => (
                  <Select.Option key={opt.value} value={opt.value}>
                    {opt.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col md={8} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            <Button type="primary" htmlType="submit" className={styles.actionButton}>
              Pretraži
            </Button>
          </Form.Item>
        </Col>
        <Col md={8} sm={24} lg={3} xl={3}>
          <Form.Item className={styles.gutterBox}>
            <Button onClick={handleReset} className={styles.actionButton}>
              Resetiraj
            </Button>
          </Form.Item>
        </Col>
        <Col md={8} sm={24} lg={5} xl={5}>
          <Form.Item className={styles.gutterBox}>
            <Button type="primary" onClick={onNew} className={styles.actionButton}>
              Nova info marke i modela
            </Button>
          </Form.Item>
        </Col>
      </Form>
    </Row>
  );
};

export default Form.create()(MakeModelInfoFilterForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageMakeModelInfoPage/MakeModelInfoFilterForm.tsx